import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  num: '01',
  title: 'BONO 1 — El Finde Perfecto en Familia',
  subtitle: '12 Planes de Cocina Sin Estrés para el Fin de Semana',
  desc: 'Cronogramas hora a hora + listas de compras + checklists imprimibles + sistema de roles por edad para que cocine toda la familia.',
  value: '$8.000'
}, {
  num: '02',
  title: 'BONO 2 — Calculadora Express de Precios',
  subtitle: 'Cobrá Bien Sin Vergüenza: Tu Precio Justo en 10 Minutos',
  desc: 'Plantillas para calcular costos reales sin Excel. Incluye gas, packaging, tiempo y merma. 8 ejemplos completos del Megapack. Guiones para subir precios sin perder clientes.',
  value: '$10.000'
}, {
  num: '03',
  title: 'BONO 3 — 120 Textos que Venden',
  subtitle: 'Biblioteca de Mensajes para WhatsApp: Copiá, Pegá y Vendé',
  desc: '120 mensajes listos para estados, difusión, cierres, objeciones y recompras. Lenguaje natural "de barrio" que no suena a vendedor.',
  value: '$9.000'
}];
export function BonusSection() {
  return <section className="py-12 px-4 bg-carbon text-cream relative overflow-hidden pt-[5px] pb-[5px]" data-id="element-22">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-green to-transparent" data-id="element-23"></div>

      <div className="max-w-5xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-white" data-id="element-26">
            🎁 3 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-green font-serif italic" data-id="element-27">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="space-y-6 mb-16" data-id="element-28">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-carbon-light rounded-2xl p-6 md:p-8 border border-carbon-lighter flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-29">
              <div className="bg-brand-green/20 text-brand-green font-bold text-3xl md:text-5xl p-4 rounded-xl font-serif min-w-[80px] text-center" data-id="element-30">
                {bono.num}
              </div>
              <div className="flex-1" data-id="element-31">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-1" data-id="element-32">
                  🎁 {bono.title}
                </h3>
                <h4 className="text-cream-dark font-medium mb-3" data-id="element-33">
                  {bono.subtitle}
                </h4>
                <p className="text-carbon-lighter text-sm md:text-base mb-4 leading-relaxed" data-id="element-34">
                  {bono.desc}
                </p>
                <div className="inline-block bg-carbon px-4 py-2 rounded-lg border border-carbon-lighter text-sm" data-id="element-35">
                  Valor:{' '}
                  <span className="line-through text-carbon-lighter" data-id="element-36">
                    {bono.value}
                  </span>{' '}
                  <span className="text-brand-green font-bold ml-2" data-id="element-37">
                    → GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        scale: 0.95,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-brand-green text-white text-center p-8 rounded-3xl shadow-2xl border-4 border-brand-greenHover" data-id="element-38">
          <p className="text-lg md:text-xl mb-2 opacity-90" data-id="element-39">
            Valor total bonos
          </p>
          <p className="text-3xl md:text-5xl font-bold font-serif" data-id="element-40">
            <span className="line-through opacity-70 text-2xl md:text-4xl mr-4" data-id="element-41">
              $27.000
            </span>
            → GRATIS{' '}
            <span className="text-xl md:text-2xl font-sans font-normal ml-2" data-id="element-42">
              con tu Megapack
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}